import { Box, ThemeProvider } from '@mui/material'
import { Outlet } from 'react-router-dom'
import UploadModal from '../components/Extractor/UploadModal'
import Header from './Layout/Header'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import ProgressModal from '../components/ProgressModal'
import theme from '../styles/theme'

function BookProcessor() {
  const isShowUploadModal = useSelector(
    (state: RootState) => state.construction.showUploadModal,
  )

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          minWidth: '800px',
        }}
      >
        <Header />
        {!isShowUploadModal && <Outlet />}
        <UploadModal />
        <ProgressModal text='Opening file'></ProgressModal>
      </Box>
    </ThemeProvider>
  )
}

export default BookProcessor
